import { BsArrowLeft } from "react-icons/bs";
import { Form, Button } from 'react-bootstrap';
import React, { useState, useEffect } from "react";
import { MdErrorOutline } from "react-icons/md";
import { BsArrowUpRight } from "react-icons/bs";
import ProductionModal from "./ProductionModal";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import MaterialInspectionReportModal from "../modal/MaterialInspectionReportMadal";
import ReviewMaterialOnHold from "../modal/ReviewMaterialOnHold";
import ReviewProductOnHold from "../modal/ReviewProductOnHold";
import Loader from "../loader/Loader";
import { formatDate } from "../../utils/formatDate"
import MaterialIssueRequstModal from "../modal/MaterialIssueRequstModal";
import ProductStockModalView from "../modal/ProductStockModalView";
import GenerateReport from '../modal/GenerateReport'
const ProductionTargetProgress = ({ item, onBack }) => {
  const productId = item?.product_id;
  const today = new Date().toISOString().slice(0, 10);
  const [materialIssue, setMaterialIssue] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [progressData, setProgressData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [materialInspection, setMaterialInspection] = useState(false)
  const [reviewMaterialOnHold, setReviewMaterialOnHold] = useState(false)
  const [reviewProductOnHold, setReviewProductOnHold] = useState(false)
  const [productionId, setProductionId] = useState(null);
  const [inholdmaterial, setInholdmaterial] = useState([])
  const [materialAlertsList, setMaterialAlertsList] = useState([])
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today)
  const [stockModal, setStockModal] = useState(false);
  const [dateWise, setDateWise] = useState(null)
  const [productHoldId, setProductHoldId] = useState(null)
  const [generateReport, setGenerateReport] = useState(false)
  // const handleAcceptClick = () => {
  //   setMaterialInspection(true);
  // };
  const fetchProductionprogresspage = async (startDate, endDate) => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const payload = {
        product_id: item?.product?.id,
        start_date: startDate,
        end_date: endDate,
      };
      const response = await axios.post(
        `${config.API}/supervisor/productionprogresspage`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setProgressData(response.data);
      }
    } catch (err) {
      console.error("Error fetching production progress:", err.message);
    } finally {
      setLoading(false);
    }
  };


  const fetchInholdmaterial = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const response = await axios.get(`${config.API}/supervisor/inholdmaterial/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setInholdmaterial(response?.data?.in_hold_material || []);
      } else {
        setInholdmaterial([]);
      }

    } catch (err) {
      console.error("Error fetching fetchMaterialStaus:", err.message);
    }
  };

  const fetchMaterialAlertsList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/supervisor/supervisorreports/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response) {
        console.log(response.data)
        setMaterialAlertsList(response?.data?.low || []);
      } else {
        setMaterialAlertsList([]);
      }
    } catch (err) {
      console.error(
        "Error fetching fetchMaterialAlertsList:",
        err.response?.data || err.message
      );
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (productId) {
      fetchProductionprogresspage();
    }
    fetchInholdmaterial();
    fetchMaterialAlertsList()
  }, [item]);

  useEffect(() => {
    console.log("productionStock:", progressData);
  }, [progressData?.productionStock]);

  useEffect(() => {
    if (startDate && endDate) {
      fetchProductionprogresspage(startDate, endDate);
    }
  }, []);


  return (
    <div className="container-fluid">
      {loading ? (
        <Loader />
      ) : (
        <div className="row gy-4">
          <div className="col-12 col-md-8">
            <div className="card p-3 h-100">
              <div className="p-2">
                <div className="d-flex align-items-start align-items-sm-center gap-2 mb-2 flex-wrap">
                  <span
                    className="btn btn-sm btn-secondary"
                    onClick={onBack}
                  >
                    <BsArrowLeft />
                  </span>
                  <strong className="fs-5 font_family text-wrap">
                    {progressData?.productname} Production Progress
                  </strong>
                </div>
                <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                  <Form.Control
                    type="date"
                    size="sm"
                    className="w-100 w-sm-auto"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                  <Form.Control
                    type="date"
                    size="sm"
                    className="w-100 w-sm-auto"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                  <Button
                    size="sm"
                    variant="primary"
                    className="w-100 w-sm-auto"
                    disabled={!startDate || !endDate}
                    onClick={() => fetchProductionprogresspage(startDate, endDate)}
                  >
                    Apply
                  </Button>
                </div>

              </div>

              {progressData?.production_progress &&
                progressData.production_progress.length > 0 ? (
                progressData.production_progress.map((step, idx) => {
                  const percentage = step?.target
                    ? ((step?.total_units_produced || 0) / step?.target) * 100
                    : 0;

                  return (
                    <div key={idx} className="mb-3">
                      <div className="d-flex justify-content-between">
                        <span
                          style={{ cursor: "pointer", fontWeight: 500 }}
                          onClick={() => {
                            setShowModal(true);
                            setProductionId(step?.machine_id);
                          }}
                        >
                          {step?.machine?.name} {step?.machine?.machine_code} <BsArrowUpRight />
                        </span>
                        <span>
                          {step?.total_units_produced}/{step?.target} (
                          {percentage.toFixed(2)}%)
                        </span>
                      </div>

                      <div className="progress" style={{ height: "8px" }}>
                        <div
                          className={`progress-bar ${percentage >= 100 ? "bg-success" : "bg-dark"
                            }`}
                          style={{ width: `${percentage}%` }}
                        ></div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center text-muted py-3">
                  No production data found
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div
              className="card p-3 h-100 font_family"
              style={{
                maxHeight: "400px",
                overflowY: "auto",
              }}
            >
              <strong className="fs-4">Inprocess Reports</strong>
              {loading ? (
                <Loader />
              ) : (
                <>
                  {materialAlertsList && materialAlertsList.length > 0 ? (
                    materialAlertsList.map((alert, index) => {
                      const available = Number(alert?.available_quantity);
                      const required = Number(alert?.required_quantity);
                      const minimum = Number(alert?.minimum_quantity);

                      return (
                        <div key={index}>
                          {available < minimum && (
                            <div className="border-start border-danger border-4 bg-danger bg-opacity-10 p-3 mb-3 rounded">
                              <p className="text-danger fw-bold mb-1">
                                <MdErrorOutline /> {alert?.material?.material_name} Stock Critical
                              </p>
                              <p className="mb-2 ms-3">
                                Only {alert?.available_quantity} pieces remaining. Minimum stock level is{" "}
                                {alert?.minimum_quantity} pieces. Reorder immediately.
                              </p>
                              <button
                                className="btn btn-sm bg-white ms-3"
                                onClick={() => setMaterialIssue(true)}
                              >
                                Request Reorder
                              </button>
                            </div>
                          )}
                          {available >= minimum && available < required && (
                            <div className="border-start border-warning border-4 bg-warning bg-opacity-10 p-3 mb-3 rounded">
                              <p className="text-warning fw-bold mb-1">
                                <MdErrorOutline /> {alert?.material?.material_name} Running Low
                              </p>
                              <p className="mb-2 ms-3">
                                Current stock: {alert?.available_quantity} pieces. Will reach minimum level
                                soon at current consumption rate.
                              </p>
                              <button className="btn bg-white btn-sm border-1 ms-2">
                                Review Usage
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })
                  ) : (
                    <div className="p-3 text-center text-muted">
                      No material alerts found
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="col-12 col-md-5">
            <div className="card p-3 h-100 font_family">
              <strong className="fs-4">In Hold Materials</strong>

              {loading ? (
                <Loader />
              ) : inholdmaterial && inholdmaterial.length > 0 ? (
                <>
                  {inholdmaterial.map((material, idx) => (
                    <div
                      key={idx}
                      className="border-start border-danger border-4 ps-3 py-2 my-2 bg-danger bg-opacity-10"
                    >
                      <strong>
                        {material?.total_qty}{" "}
                        {material?.material_master?.material_name} Pieces{" "}
                        {formatDate(material?.day)}
                      </strong>

                      <p className="small">
                        {material?.material_master?.material_name} on hold due to undefined NC
                      </p>

                      <button
                        className="btn btn-sm bg-white"
                        onClick={() => { setReviewMaterialOnHold(true) }}
                      >
                        Review Hold
                      </button>
                    </div>
                  ))}
                </>
              ) : (
                <p className="text-center text-muted mt-3">
                  Data not found
                </p>
              )}
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="card p-3 h-100">
              <div className="d-flex align-items-center gap-3">
                <strong className="fs-5">
                  {progressData?.productname} Production Stock
                </strong>
                <button
                  className="btn btn-dark small-btn text-nowrap"
                  onClick={() => setGenerateReport(true)}
                >
                  Generate Report
                </button>
              </div>
              <div className="table-responsive mt-3">
                <table className="table table-sm">
                  <thead className="table-light">
                    <tr>
                      <th>Date</th>
                      <th>Production Date</th>
                      <th>Opening</th>
                      <th>Produced</th>
                      <th>Dispatched</th>
                      <th>Rejected</th>
                      <th>Closing</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {progressData?.productionStock?.length > 0 ? (
                      progressData.productionStock.map((productrow) => (
                        <tr key={productrow.date}>
                          <td>{formatDate(productrow.date)}</td>
                          <td>
                            {productrow?.production_date
                              ? formatDate(productrow.production_date)
                              : "No Production"}
                          </td>
                          <td>{productrow.opening_stock}</td>
                          <td>{productrow.stock_in}</td>
                          <td>{productrow.dispatched_stock}</td>
                          <td>{productrow.rejected_stock}</td>
                          <td>{productrow.closing_stock}</td>
                          <td><button className="btn btn-sm btn-secondary" onClick={() => { setStockModal(true); setDateWise(productrow?.date) }}>View</button></td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12">
            <div className="card p-3 h-100">
              <strong className="fs-4">In Hold Product</strong>
              <div className="table-responsive mt-3">
                <table className="table table-sm" style={{ borderCollapse: "separate", borderSpacing: "0 10px" }}>
                  <thead className="table-light">
                    <tr>
                      <th>PO Number</th>
                      <th>Machine</th>
                      <th>Produced</th>
                      <th>User Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {progressData?.in_hold_product?.length > 0 ? (
                      progressData.in_hold_product.map((item) => (
                        <tr key={item.id} className="table-danger ">
                          <td>{item?.purchase_order?.po_number}</td>
                          <td>{item.machine?.name} | {item.machine?.machine_code}</td>
                          <td>{item.product?.name}</td>
                          <td>{item.user?.name}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-secondary text-nowrap mt-2"
                              onClick={() => {
                                setReviewProductOnHold(true);
                                setProductHoldId(item?.id);
                              }}
                            >
                              Review Hold
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <ProductionModal
          show={showModal}
          productionId={productionId}
          handleClose={() => setShowModal(false)}
        />
      )}

      {/* MaterialInspectionReportModal */}
      <MaterialInspectionReportModal
        show={materialInspection}
        handleClose={() => setMaterialInspection(false)}
      />
      {/* MaterialInspectionReportModal */}
      <ReviewMaterialOnHold
        inholdmaterialId={productId}
        show={reviewMaterialOnHold}
        handleClose={() => setReviewMaterialOnHold(false)}
      />

      <ReviewProductOnHold
        inholdproductId={productHoldId}
        show={reviewProductOnHold}
        handleClose={() => setReviewProductOnHold(false)}
      />
      {/* MaterialIssueRequstModal */}
      <MaterialIssueRequstModal
        show={materialIssue}
        // onMaterialAdded={fetchMaterialList}
        handleClose={() => setMaterialIssue(false)}
      />
      <ProductStockModalView
        show={stockModal}
        dateWise={dateWise}
        productId={productId}
        handleClose={() => setStockModal(false)}
      />
      <GenerateReport
        show={generateReport}
        handleClose={() => setGenerateReport(false)}
      />
    </div>
  );
};

export default ProductionTargetProgress;
